module.exports = __webpack_public_path__ + "static/media/bite.d2b7c952.png";